import { createAction } from 'redux-act';
/////////////////////////////////////////////////

export const createTelRateActionRequest = createAction('createTelRateActionRequest');
export const createTelRateActionSuccess = createAction('createTelRateActionSuccess');
export const updateTelRateActionRequest = createAction('updateTelRateActionRequest');
export const updateTelRateActionSuccess = createAction('updateTelRateActionSuccess');
export const createTelCarrierRateActionRequest = createAction('createTelCarrierRateActionRequest');
export const updateTelCarrierRateActionRequest = createAction('updateTelCarrierRateActionRequest');
